import React from 'react';
import { Header } from '@/components';
import { SignupHero } from '@/features/user/components/signup';

const SignupPage: React.FC = () => {
  return (
    <div className="bg-black min-h-screen">
      <Header />
      <SignupHero />
    </div>
  );
};

export default SignupPage;
